import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as Highcharts from 'highcharts';
import { PeerAnalysis } from 'src/app/models/analysis/peer-analysis.model';
import { DeconcentrationAnalysis } from 'src/app/models/analysis/deconcentration-analysis.model';

@Component({
  selector: 'app-peers-widget-chart',
  templateUrl: './peers-widget-chart.component.html',
  styleUrls: ['./peers-widget-chart.component.scss']
})
export class PeersWidgetChartComponent implements OnInit {

  @Input() originalPA: PeerAnalysis;
  @Input() investablePA: PeerAnalysis;
  @Input() protectedPA: PeerAnalysis;
  @Input() target1PA: PeerAnalysis;
  @Input() target2PA: PeerAnalysis;
  @Input() target3PA: PeerAnalysis;

  @Input() adjustedTargetPA: PeerAnalysis;

  @Input() target: string = 'deconcentration';
  @Input() peerProducts: DeconcentrationAnalysis[];
  @Input() peerFunds: DeconcentrationAnalysis[];
  @Input() selectedType: string;
  @Input() selectedIndex: number;

  showLegend: boolean = false;
  showGraph: boolean = true;

  chart: typeof Highcharts = Highcharts;
  portfolioSeries:any = [];
  productSeries:any = [];
  fundSeries:any = [];
  chartOptions: Highcharts.Options;
  chartXLabel: string;

  @Output() selectedPeerChange = new EventEmitter();

  portfolioSeriesInfos = [{
    key: 'originalPA',
    name: 'Original',
    type: 'original',
    color: 'rgba(227,143,72, 1)',
    lineColor: 'rgba(227,143,72, 1)'
  },{
    key: 'investablePA',
    name: 'Investable',
    type: 'investable',
    color: 'rgba(129,186,241, 1)',
    lineColor: 'rgba(129,186,241, 1)'
  },{
    key: 'protectedPA',
    name: 'Protected',
    type: 'protected',
    color: 'rgba(94,187,75, 1)',
    lineColor: 'rgba(94,187,75, 1)'
  },{
    key: 'target1PA',
    name: 'Target Strategy 1',
    type: 'target1',
    color: 'rgba(40,106,172,0.75)',
    lineColor: 'rgba(40,106,172,0.75)'
  },{
    key: 'target2PA',
    name: 'Target Strategy 2',
    type: 'target2',
    color: 'rgba(145,187,225,0.75)',
    lineColor: 'rgba(145,187,225,0.75)'
  },{
    key: 'target3PA',
    name: 'Target Strategy 3',
    type: 'target3',
    color: 'rgba(180,209,236,0.75)',
    lineColor: 'rgba(180,209,236,0.75)'
  },{
    key: 'adjustedTargetPA',
    name: 'Adjusted Target',
    type: 'adjustedTarget',
    color: 'rgba(94,187,75, 1)',
    lineColor: 'rgba(94,187,75, 1)'
  }]

  constructor() {
  }

  ngOnInit(): void {
    switch (this.target) {
      case 'diversification': this.chartXLabel = 'Effective Number of Risks'; break;
      case 'deconcentration':
      default:
        this.chartXLabel = 'Effective Number of Factors';
        break;
    }
    let thisComponent = this;


    this.portfolioSeriesInfos.filter(
      (portfolio) => {
        return thisComponent[portfolio.key]!=undefined;
      }
    ).forEach(
      (portfolio) => {
        thisComponent.portfolioSeries.push({
          name: portfolio.name,
          color: portfolio.color,
          data: [thisComponent[portfolio.key]].map(
            (peerProduct, index) => {
              let val:number;
              if (thisComponent.target=='diversification') {
                val = thisComponent[portfolio.key].effective_nb_of_factor_bets;
              } else {
                val = thisComponent[portfolio.key].effective_nb_of_factors
              }
              return {
                x: val,
                y: thisComponent[portfolio.key].factor_intensity,
                name: thisComponent[portfolio.key].name,
                selected: thisComponent.isSelected(portfolio.type)
              }
            }
          ),
          type: 'scatter',
          marker: {
            symbol: 'diamond',
            states: {
              select: {
                fillColor: portfolio.color,
                lineColor: portfolio.lineColor,
              }
            }
          },
          point: {
            events: {
              select: function () {
                thisComponent.selectedPeerChange.emit({
                  type: portfolio.type
                });
                console.log(portfolio.name+' Portfolio selected');
              }
            }
          }
        });
      }
    );

    if (this.peerProducts && this.peerProducts.length) {
      let productColor: string, productLineColor: string;
      if (thisComponent.target=='diversification') {
        productColor = 'rgb(223, 83, 83)';
        productLineColor = 'rgb(255, 255, 255)';
      } else {
        productColor = 'rgb(145,187,225)';
        productLineColor = 'rgb(255,255,255)';
      }
      thisComponent.productSeries.push({
        name: 'Products',
        color: productColor,
        data: thisComponent.peerProducts.map(
          (peerProduct, index) => {
            let val:number;
            if (thisComponent.target=='diversification') {
              val = peerProduct.effective_nb_of_factor_bets;
            } else {
              val = peerProduct.effective_nb_of_factors
            }
            return {
              x: val,
              y: peerProduct.factor_intensity,
              name: peerProduct.name,
              selected: thisComponent.isSelected('product', index)
            }
          }
        ),
        type: 'scatter',
        marker: {
          symbol: 'diamond',
          states: {
            select: {
              fillColor: productColor,
              lineColor: productLineColor,
            }
          }
        },
        point: {
          events: {
            select: function () {
              thisComponent.selectedPeerChange.emit({
                type: 'product',
                index: this.index
              });
              console.log('Product ' + this.index + ' selected');
            }
          }
        }
      });
    }

    if (this.peerFunds && this.peerFunds.length) {
      let productColor: string = 'rgba(153, 153, 153, .5)',
          productLineColor: string = 'rgba(153, 153, 153, .5)';
      thisComponent.fundSeries.push({
        name: 'Products',
        color: productColor,
        data: thisComponent.peerFunds.map(
          (peerFund, index) => {
            let val;
            switch (thisComponent.target) {
              case 'diversification': val = peerFund.effective_nb_of_factor_bets; break;
              case 'deconcentration':
              default:
                val = peerFund.effective_nb_of_factors
                break;
            }
            return {
              x: val,
              y: peerFund.factor_intensity,
              name: peerFund.name,
              selected: thisComponent.isSelected('fund', index)
            }
          }
        ),
        type: 'scatter',
        marker: {
          symbol: 'circle',
          states: {
            select: {
              fillColor: productColor,
              lineColor: productLineColor,
            }
          }
        },
        point: {
          events: {
            select: function () {
              thisComponent.selectedPeerChange.emit({
                type: 'fund',
                index: this.index
              });
              console.log('Product ' + this.index + ' selected');
            }
          }
        }
      });
    }

    this.chartOptions = {
      chart: {
        zoomType: 'xy',
        backgroundColor: 'rgba(255,255,255,0)'
      },
      title: {
        text: null
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: true
      },
      navigation: {
        buttonOptions: {
          verticalAlign: 'bottom',
        }
      },
      xAxis: {
        title: {
            text: thisComponent.chartXLabel
        },
        min: 0,
        max: 6.1,
        lineColor: 'transparent',
        tickLength: 0
      },
      yAxis: {
        title: {
            text: 'Factor Intensity'
        },
        min: 0,
        max: 1.1,
        gridLineDashStyle: "Dash",
        gridLineColor: 'grey',
      },
      legend: {
        enabled: this.showLegend
      },
      tooltip: {
        useHTML: true,
        formatter: function () {
          return '<strong>' + this.point.name + '</strong>'+
          '<table style="position: relative; z-index: 1151;">' +
          '    <tr>' +
          '        <td class="text-left card-text" style="font-size:0.8em">' + thisComponent.chartXLabel + ': </td>' +
          '        <td class="text-left card-text" style="font-size:0.8em">' + this.point.x.toFixed(4) + '</td>' +
          '    </tr>' +
          '    <tr>' +
          '        <td class="text-left card-text" style="font-size:0.8em">Factor Intensity: </td>' +
          '        <td class="text-left card-text" style="font-size:0.8em">' + this.point.y.toFixed(4) + '</td>' +
          '    </tr>' +
          '</table>';
        },
        style: {
          color: 'rgb(118,168,255)',
        }
      },
      plotOptions: {
        scatter: {
          allowPointSelect: true,
          marker: {
            radius: 5,
            states: {
              select: {
                radius: 7
              }
            }
          }
        }
      },
      series: [].concat(
        thisComponent.portfolioSeries,
        thisComponent.productSeries,
        thisComponent.fundSeries
      )
    };
  }

  setChartSeriesSelection() {
    let thisComponent = this;
    this.portfolioSeriesInfos.filter(
      (portfolio) => {
        return thisComponent[portfolio.key]!=undefined;
      }
    ).forEach(
      (portfolio,index) => {
        thisComponent.portfolioSeries[index].data.forEach((point) => {
          point.selected = thisComponent.isSelected(portfolio.type)
        });
      }
    );

    if (this.peerProducts && this.peerProducts.length) {
      thisComponent.productSeries[0].data.forEach((point, index) => {
        point.selected = thisComponent.isSelected('product', index)
      })
    }

    if (this.peerFunds && this.peerFunds.length) {
      thisComponent.fundSeries[0].data.forEach((point, index) => {
        point.selected = thisComponent.isSelected('fund', index)
      })
    }
  }

  isSelected(type: string, index?: number) {
    if (index==undefined){
      if (this.selectedType) {
        return (this.selectedType==type);
      }
    } else {
      if (this.selectedType && this.selectedIndex!=undefined) {
        return (this.selectedType==type && this.selectedIndex==index);
      }
    }
    return false;
  }

  redraw() {
    this.showGraph = false;
    this.setChartSeriesSelection();
    setTimeout(()=>{
      this.showGraph = true;
    }, 100);
  }

}
